import React, { Component } from "react";
import { components } from "react-select";
import { Modal, Form, Col, Button, Card, Container, Row } from "react-bootstrap";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import moment from "moment";
import SampleExcel from '../../../images/marksSample.xls';
import { ExcelRenderer } from 'react-excel-renderer';
import TableSearchwithStudentResult from "../questioners/manage_questin_papers/TableSearchwithStudentResult";
import './_studentMarks.scss'

class MarksUploadingModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dataClear: 0,
            marksData: [],
            fileError: "",
            rows: [],
            cols: [],

        }
    }

    componentDidUpdate() {
        if (this.props.show === true && this.state.dataClear == 0) {
            this.setState({ dataClear: 1, marksData: [], fileError: "", rows: [], cols: [] })
        }
        if (this.props.show === false && this.state.dataClear == 1) {
            this.setState({ dataClear: 0 })
        }
    }

    handleFileChange = e => {
        this.setState({
            StudentsFilterData: [],
            cols: []
        });
        let fileObj = e.target.files[0];
        console.log("fileObj",e);
        let fileType = ['application/vnd.ms-excel'];

        if (!fileType.includes(fileObj.type)) {
            this.setState({
                fileError: "Ivalid Format"
            });
            return ""
        }

        //just pass the fileObj as parameter
        ExcelRenderer(fileObj, (err, resp) => {
            console.log("res", resp);
            if (err) {
                console.log(err);
            }
            else {
                this.setState({
                    cols: resp.cols,
                    rows: resp.rows
                });
                let studentData = []
                if (resp.rows) {
                    let rowData = resp.rows.slice(1);
                    console.log("rowData", rowData)
                    if (rowData) {
                        rowData.map(item => {
                            if (item[0] != undefined && item[1] != undefined && item[2] != undefined && item[3] != undefined && item[4] != undefined && item[5] != undefined && item[6] != undefined && item[7] != undefined) {
                                studentData.push({ student_name: item[1].toString(), roll_number: item[2].toString(), total_marks: item[3].toString(), marks_obtained: item[4].toString(), Physics: item[5].toString(), Chemistry: item[6].toString(), Mathematics: item[7].toString() })
                            }
                        });
                    }
                }

                this.setState({
                    marksData: studentData,
                    fileError: ""
                });
            }
        });
    }

    handleFormSubmit = (e) => {
        this.props.onHide()
    }

    render() {
        console.log("asasasasas", this.state)

        if (this.state.marksData.length > 0) {
            console.log("chaitu", Object.keys(this.state.marksData[0]))
        }

        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="marks_table"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Upload Marks</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <h6 className="text-center">Please upload an Excel with the given format</h6>
                    <Form.Group controlId="formFile" as={Col} lg={4} md={12} sm={12} className="center_align">
                        <Form.Label ><a href={SampleExcel} download>Download sample file</a></Form.Label>
                        <Form.Control name="file" type="file" onChange={this.handleFileChange} >
                        </Form.Control>
                        <Form.Text className="form-text text-danger">
                            {this.state.fileError}
                        </Form.Text>
                    </Form.Group>

                </Modal.Body>

                <Modal.Footer variant="white" className="px-1">
                    <Row>
                        <Col sm={12} style={{ display: "block", textAlign: "center" }}>
                            <Button className="btn btn-success text-uppercase" onClick={this.handleFormSubmit}>
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default MarksUploadingModal;